// extracted by mini-css-extract-plugin
module.exports = {"root":"Container_root__sBw7Q","background":"Container_background__uQYtX","search":"Container_search__sWDKk","main":"Container_main__TaJHq"};